import View from './AccountsWorkflowView';

export default View;
